import React from "react";
import PropTypes from "prop-types";
import { TasksCardTemplate } from 'themes/application/dashboard/components';
import { observer } from 'mobx-react';

@observer
class TasksCard extends React.Component {
    render() {
        return <TasksCardTemplate {...this.props} />;
    }
}

TasksCard.propTypes = {
    title: PropTypes.string,
    data: PropTypes.object
};

export default TasksCard;
